export default {
  isHidden: false,
  isUploading: false,
  uploads: [],
  FILE_CHUNK_SIZE: 50000000, // 50000000 = 50MB
}
